import { defineMessages } from "react-intl";

export default defineMessages({
  year: {
    id: "policy.ho.directives.policy-dwelling-wcMotor-Details.Year",
    defaultMessage: "Year",
  },
  make: {
    id: "policy.ho.directives.policy-dwelling-wcMotor-Details.Make",
    defaultMessage: "Make",
  },

  model: {
    id: "policy.ho.directives.policy-dwelling-wcMotor-Details.Model",
    defaultMessage: "Model",
  },
  serialVin: {
    id: "policy.ho.directives.policy-dwelling-wcMotor-Details.Serial/VIN",
    defaultMessage: "Serial/VIN",
  },
  speed: {
    id: "policy.ho.directives.policy-dwelling-wcMotor-Details.Speed",
    defaultMessage: "Speed",
  },
  hp: {
    id: "policy.ho.directives.policy-dwelling-wcMotor-Details.HP",
    defaultMessage: "HP",
  },
  Value: {
    id: "policy.ho.directives.policy-dwelling-wcMotor-Details.Value",
    defaultMessage: "Value",
  },
  motorTrailerEquipment: {
    id: "policy.ho.directives.policy-dwelling-wcMotor-Details.Motor/Trailer/Equipment",
    defaultMessage: "Motor/Trailer/Equipment",
  },
  motorTrailerEquipmentDetails: {
    id: "policy.ho.directives.policy-dwelling-wcMotor-Details.Motor, Trailer and Equipment Details",
    defaultMessage: "Motor, Trailer and Equipment Details",
  },
});
